var _style, _path, _path2, _path3, _g, _path4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g9, _g10, _path13, _g11, _g12, _g13, _path14, _g14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g15, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _polygon2, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.99 294.62",
    style: {
      enableBackground: "new 0 0 458.99 294.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:#FDCEDC;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#84ACB9;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:#F59F7E;}\n\t.st10{fill:#AFD4C2;}\n\t.st11{opacity:0.2;enable-background:new    ;}\n\t.st12{fill:url(#SVGID_7_);}\n\t.st13{fill:url(#SVGID_8_);}\n\t.st14{fill:url(#SVGID_9_);}\n\t.st15{opacity:0.3;enable-background:new    ;}\n\t.st16{fill:url(#SVGID_10_);}\n\t.st17{fill:url(#SVGID_11_);}\n\t.st18{fill:url(#SVGID_12_);}\n\t.st19{fill:url(#SVGID_13_);}\n\t.st20{fill:url(#SVGID_14_);}\n\t.st21{fill:url(#SVGID_15_);}\n\t.st22{fill:url(#SVGID_16_);}\n\t.st23{fill:url(#SVGID_17_);}\n\t.st24{fill:#FCFCFC;}\n\t.st25{fill:url(#SVGID_18_);}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{fill:url(#SVGID_25_);}\n\t.st33{fill:url(#SVGID_26_);}\n\t.st34{fill:url(#SVGID_27_);}\n\t.st35{fill:url(#SVGID_28_);}\n\t.st36{fill:url(#SVGID_29_);}\n\t.st37{fill:url(#SVGID_30_);}\n\t.st38{fill:url(#SVGID_31_);}\n\t.st39{opacity:0.2;fill:#201600;enable-background:new    ;}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{fill:url(#SVGID_33_);}\n\t.st42{fill:url(#SVGID_34_);}\n\t.st43{fill:url(#SVGID_35_);}\n\t.st44{fill:url(#SVGID_36_);}\n\t.st45{fill:url(#SVGID_37_);}\n\t.st46{fill:url(#SVGID_38_);}\n\t.st47{fill:url(#SVGID_39_);}\n\t.st48{fill:url(#SVGID_40_);}\n\t.st49{fill:url(#SVGID_41_);}\n\t.st50{fill:url(#SVGID_42_);}\n\t.st51{fill:url(#SVGID_43_);}\n\t.st52{fill:url(#SVGID_44_);}\n\t.st53{fill:url(#SVGID_45_);}\n\t.st54{opacity:0.5;enable-background:new    ;}\n\t.st55{fill:url(#SVGID_46_);}\n\t.st56{fill:url(#SVGID_47_);}\n\t.st57{fill:url(#SVGID_48_);}\n\t.st58{fill:url(#SVGID_49_);}\n\t.st59{fill:url(#SVGID_50_);}\n\t.st60{fill:url(#SVGID_51_);}\n\t.st61{fill:url(#SVGID_52_);}\n\t.st62{fill:url(#SVGID_53_);}\n\t.st63{fill:url(#SVGID_54_);}\n\t.st64{fill:url(#SVGID_55_);}\n\t.st65{fill:url(#SVGID_56_);}\n\t.st66{fill:url(#SVGID_57_);}\n\t.st67{fill:url(#SVGID_58_);}\n\t.st68{fill:url(#SVGID_59_);}\n\t.st69{fill:url(#SVGID_60_);}\n\t.st70{fill:url(#SVGID_61_);}\n\t.st71{fill:#201600;}\n\t.st72{fill:url(#SVGID_62_);}\n\t.st73{fill:url(#SVGID_63_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.036,
    y1: -973.0127,
    x2: 425.64,
    y2: -623.8243,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAD3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EABB8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.99,291.62V45.63c-17,21.12-52.46,29.12-69.83,29.12c-23.33,0-92.67,7.55-92.67,64.89 c0,57.33-41.39,28.83-86.67,74.11c-32.28,32.28-54,80.86-126,80.86h372.16C457.65,294.62,458.99,293.28,458.99,291.62z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.11,138.43c-1.26-0.93-1.27-1.89-1.72-3.11c-0.46-1.22-3.21-2.95-4.78-2.81 c-1.57,0.13-2.87,0.63-2.87,0.63c1.24,1.23,3.47,0.96,4.37,2.08c0.89,1.13,1.01,1.45,1.37,1.84c-1.04-0.27-1.29-0.26-1.8-0.92 c-0.79-1.04-1.52-1.54-1.99-0.96c0.59,0.44,1.27,1.45,1.62,1.87c0.36,0.42,1.4,2.29,2.46,2.17s1.87,0.09,2.54,0.63 S394.11,138.43,394.11,138.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.43,
    y1: -685.0223,
    x2: 285.1559,
    y2: -685.0223,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A32F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26F397"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.68,70.55c0.12,0.06,0.25,0.13,0.37,0.21c10.69,6.11,12.84,17.44,1.74,25.13c0,0.03,0,0.06-0.01,0.08 c-0.04,0.45-0.11,0.89-0.21,1.31c-1.93,8.39-13.79,15.59-23.02,8.47c-1.82-1.4-3.57-3.04-5.24-4.87 c-0.23-0.26-0.47-0.53-0.69-0.8c-2.25-2.59-4.32-5.53-6.16-8.72c-0.17-0.29-0.34-0.58-0.51-0.89c-1.51-2.71-2.86-5.58-4.01-8.54 c-0.12-0.33-0.24-0.65-0.37-0.97c-1.34-3.62-2.37-7.37-3.05-11.11c-0.03-0.15-0.06-0.29-0.09-0.45c0.3-0.1,0.62-0.2,0.93-0.29 c3.96-1.21,8.24-1.97,12.5-2.33c0.34-0.04,0.7-0.06,1.04-0.09c4.24-0.31,8.44-0.24,12.32,0.13c0.34,0.03,0.68,0.06,1.02,0.1 c5.23,0.58,9.79,1.74,12.9,3.32C275.32,70.36,275.5,70.45,275.68,70.55z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.56,97.29l0.21-1.32c-2.55-2.19-5.24-4.27-8-6.3l0,0l6.27-18.91c-0.11-0.08-0.25-0.15-0.37-0.21 c-0.18-0.1-0.36-0.19-0.56-0.28l-6.22,18.78c-3.02-2.18-6.12-4.26-9.19-6.23l2.51-15.87c-0.34-0.04-0.67-0.08-1.02-0.1 l-2.43,15.38c-3.7-2.33-7.35-4.47-10.78-6.38l0,0l0.89-9.13c-0.34,0.02-0.69,0.05-1.04,0.09l-0.82,8.5l0,0H247 c-4.45-2.5-8.47-4.57-11.66-6.16c-0.31,0.08-0.63,0.17-0.94,0.28c0.04,0.16,0.07,0.3,0.1,0.45c2.93,1.47,7.12,3.62,11.95,6.33 l0,0l0,0l-8.9,4.78c0.13,0.32,0.25,0.64,0.37,0.97l9.5-5.12l-0.08-0.12c3.29,1.84,6.83,3.94,10.46,6.23l0,0l-15.88,7.55 c0.16,0.3,0.34,0.6,0.51,0.89l16.38-7.8l0,0c3.17,2.02,6.36,4.18,9.5,6.45l0,0l0,0l-19.72,10.07c0.23,0.27,0.46,0.54,0.69,0.8 l19.86-10.15l-0.08-0.18l0.01-0.01C272.01,92.71,274.86,94.97,277.56,97.29z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.8693,
    y1: -716.9004,
    x2: 383.73,
    y2: -716.9004,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A32F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26F397"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.3,138.59c-0.13,0.05-0.27,0.11-0.4,0.15c-11.58,4.27-21.66-1.38-20.41-14.85 c-0.02-0.02-0.05-0.04-0.06-0.07c-0.32-0.31-0.61-0.66-0.87-1.01c-5.2-6.89-3.09-20.63,8.32-23.13c2.25-0.5,4.63-0.79,7.11-0.89 c0.35-0.01,0.7-0.02,1.06-0.02c3.43-0.06,7.02,0.25,10.66,0.89c0.34,0.06,0.67,0.11,1.01,0.18c3.05,0.58,6.13,1.4,9.14,2.43 c0.33,0.12,0.66,0.24,0.98,0.34c3.64,1.31,7.18,2.93,10.49,4.81c0.14,0.08,0.27,0.14,0.4,0.22c-0.12,0.3-0.24,0.6-0.38,0.89 c-1.62,3.82-3.8,7.59-6.26,11.1c-0.19,0.29-0.4,0.58-0.6,0.85c-2.49,3.46-5.25,6.64-8.04,9.37c-0.24,0.25-0.49,0.48-0.73,0.71 c-3.82,3.64-7.65,6.4-10.86,7.76C356.68,138.43,356.49,138.51,356.3,138.59z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.43,123.82c3.32-0.55,6.65-1.27,9.99-2.08c0.35-0.09,0.7-0.18,1.04-0.27 c3.62-0.91,7.22-1.96,10.71-3.04c0.35-0.12,0.7-0.22,1.06-0.34c4.17-1.34,8.17-2.76,11.85-4.17c0.35-0.12,0.71-0.25,1.04-0.4 c4.78-1.8,8.97-3.56,12.24-4.98c0.14-0.29,0.27-0.6,0.39-0.9c-0.14-0.07-0.28-0.14-0.41-0.22c-3.01,1.3-7.37,3.13-12.56,5.1 c-0.3,0.13-0.64,0.24-0.94,0.35h-0.01c-3.53,1.33-7.43,2.71-11.53,4.02c-0.38,0.13-0.77,0.23-1.14,0.37 c-3.59,1.13-7.3,2.19-11.07,3.13c-0.3,0.07-0.59,0.15-0.9,0.22v0.01c-3.54,0.86-7.1,1.6-10.63,2.17L335.43,123.82z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.51,120.49l-6.43-6.57l-0.17-0.17l0.72-0.71h0.01l0.01,0.01l0.01-0.01l0.46,0.48l5.99,6.11 C376.92,119.92,376.71,120.21,376.51,120.49z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.67,113.06h-0.03l-0.02-0.01l-0.79-0.17l-0.16-0.03l2.19-10.59c0.33,0.12,0.66,0.24,0.98,0.34 l-2.07,9.91L370.67,113.06z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.74,130.57l-10.57-12.15l-0.42-0.48l0.69-0.59l0.09-0.08l0.11,0.13l0.59,0.68l10.24,11.78 C368.23,130.11,367.98,130.34,367.74,130.57z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358.14,117.53l-0.5-0.12l-0.2-0.05l-0.3-0.07l0.01-0.02l4.57-17.6c0.34,0.06,0.67,0.11,1.01,0.18 l-4.43,17.05L358.14,117.53z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.3,138.59c-0.13,0.05-0.27,0.11-0.4,0.15l-10.48-17.01l-0.14-0.24l0.88-0.54l0.31,0.51l10.41,16.87 C356.68,138.43,356.49,138.51,356.3,138.59z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M345.99,120.8l-0.8-0.18l-0.2-0.05l5-21.78c0.35-0.01,0.7-0.02,1.06-0.02l-4.98,21.62L345.99,120.8z"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M364.01,68.13v169.15c0,4.12-3.34,7.45-7.46,7.45H276.4c-4.12,0-7.46-3.33-7.46-7.45V68.13 c0-4.12,3.34-7.46,7.46-7.46h80.15C360.67,60.67,364.01,64.01,364.01,68.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -59.2742,
    y1: -1707.5427,
    x2: -56.4465,
    y2: -1707.5427,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -615.5646 -1367.1595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.48,66.26c-0.78,0-1.41-0.63-1.41-1.41c0-0.78,0.63-1.41,1.41-1.41s1.41,0.63,1.41,1.41 S317.26,66.26,316.48,66.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -138.3825,
    y1: -1792.6495,
    x2: 22.6605,
    y2: -1792.6495,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -664.3862 -1351.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M273.49,228.26V71.67c0-1.23,1-2.23,2.23-2.23h81.52c1.23,0,2.23,1,2.23,2.23v156.58c0,1.23-1,2.23-2.23,2.23 h-81.52C274.49,230.49,273.49,229.49,273.49,228.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -60.7326,
    y1: -1880.2842,
    x2: -54.9902,
    y2: -1880.2842,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -714.652 -1335.9174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M313.61,237.6c0-1.59,1.29-2.87,2.87-2.87c1.59,0,2.87,1.29,2.87,2.87c0,1.59-1.29,2.87-2.87,2.87 C314.89,240.47,313.61,239.19,313.61,237.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M349.65,138.27h-66.33c-1.66,0-3-1.34-3-3V79.24c0-1.66,1.34-3,3-3h66.33c1.66,0,3,1.34,3,3v56.02 C352.65,136.92,351.3,138.27,349.65,138.27z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M349.65,223.68h-66.33c-1.66,0-3-1.34-3-3v-35.06c0-1.66,1.34-3,3-3h66.33c1.66,0,3,1.34,3,3v35.06 C352.65,222.34,351.3,223.68,349.65,223.68z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M310.02,175.95h-26.71c-1.66,0-3-1.34-3-3v-25.01c0-1.66,1.34-3,3-3h26.71c1.66,0,3,1.34,3,3v25.01 C313.02,174.61,311.67,175.95,310.02,175.95z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M349.6,175.95h-26.7c-1.66,0-3-1.34-3-3v-25.01c0-1.66,1.34-3,3-3h26.7c1.66,0,3,1.34,3,3v25.01 C352.6,174.61,351.26,175.95,349.6,175.95z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.72,107.3c-5.9,0-10.7-4.8-10.7-10.7c0-5.9,4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7 S337.62,107.3,331.72,107.3z M331.72,91.9c-2.59,0-4.7,2.11-4.7,4.7s2.11,4.7,4.7,4.7s4.7-2.11,4.7-4.7S334.32,91.9,331.72,91.9z "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.72,107.3c-5.9,0-10.7-4.8-10.7-10.7c0-5.9,4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7h-6 c0-2.59-2.11-4.7-4.7-4.7s-4.7,2.11-4.7,4.7s2.11,4.7,4.7,4.7V107.3z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M301.23,107.3c-5.9,0-10.7-4.8-10.7-10.7c0-5.9,4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7 C311.93,102.5,307.13,107.3,301.23,107.3z M301.23,91.9c-2.59,0-4.7,2.11-4.7,4.7s2.11,4.7,4.7,4.7s4.7-2.11,4.7-4.7 C305.93,94.01,303.82,91.9,301.23,91.9z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.23,107.3c-5.9,0-10.7-4.8-10.7-10.7h6c0,2.59,2.11,4.7,4.7,4.7V107.3z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.72,127.87h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 S310.92,127.87,310.72,127.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.58,127.87h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 C303.93,127.71,303.77,127.87,303.58,127.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.72,119.16h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 C311.08,119.01,310.92,119.16,310.72,119.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.58,119.16h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 C303.93,119.01,303.77,119.16,303.58,119.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.71,123.81h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 C297.06,123.65,296.9,123.81,296.71,123.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.72,123.81h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 C311.08,123.65,310.92,123.81,310.72,123.81z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.21,127.87h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 C341.57,127.71,341.41,127.87,341.21,127.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.07,127.87h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 S334.27,127.87,334.07,127.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.21,119.16h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 C341.57,119.01,341.41,119.16,341.21,119.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.07,119.16h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 C334.43,119.01,334.27,119.16,334.07,119.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.2,123.81h-4.96c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.96c0.2,0,0.36,0.16,0.36,0.36 C327.56,123.65,327.4,123.81,327.2,123.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.21,123.81h-11.83c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h11.83c0.2,0,0.36,0.16,0.36,0.36 C341.57,123.65,341.41,123.81,341.21,123.81z"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.85,219.21c5.53-11.05,12.59-19.42,21.68-15.86s16.29,2.06,21.44-2.94s11.87-10.14,18.13-9.07v27.88 L285.85,219.21L285.85,219.21z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.3,219.44l-0.89-0.45c6.98-13.97,14.28-19.24,22.31-16.11c8.39,3.28,15.63,2.3,20.91-2.83 c7.29-7.08,13.36-10.09,18.57-9.21l-0.17,0.99c-4.87-0.83-10.65,2.09-17.7,8.94c-5.59,5.43-13.19,6.48-21.97,3.05 C299.89,200.9,293.01,206.01,286.3,219.44z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M295.26,129.5v21.58c0,0.44-0.09,0.86-0.25,1.24c-0.48,1.15-1.62,1.95-2.94,1.95h-7.18l-1.25,4l-2.9,9.23 l-3.66,11.66c-0.46,1.46-1.81,2.46-3.34,2.46h-4.8v-56.6c1.5,0.36,3.02,0.65,4.55,0.86c2.06,0.28,4.14,0.43,6.22,0.43h12.36 C293.83,126.31,295.26,127.74,295.26,129.5z"
  })), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M262.01,166.9h-5.39c-0.61,0-1.04-0.59-0.86-1.17l1.98-6.3c0.11-0.37,0.45-0.61,0.84-0.61h3.44L262.01,166.9 L262.01,166.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M282.74,136.04l-0.48,1.53l-4.62,14.7l-6.56,20.9c-0.46,1.46-1.81,2.45-3.34,2.45h-10.93 c-1.13,0-1.93-1.1-1.6-2.17l6.12-19.46l5.64-17.95H282.74z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.14,143.35L226.14,143.35c-5.02,0-9.08-4.07-9.08-9.08l0,0c0-5.02,4.07-9.08,9.08-9.08l0,0 c5.02,0,9.08,4.07,9.08,9.08l0,0C235.22,139.29,231.15,143.35,226.14,143.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -162.5571,
    y1: -1777.369,
    x2: -123.8981,
    y2: -1777.369,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -670.9067 -1403.7899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3011,
    style: {
      stopColor: "#F59F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6384,
    style: {
      stopColor: "#F59F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9921,
    style: {
      stopColor: "#F59F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59F55"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.3,159.27h-11.17c-1.11,0-2-0.89-2-2v-45.96c0-1.11,0.89-2,2-2h11.17V159.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -116.2636,
    y1: -1787.2921,
    x2: -88.8246,
    y2: -1787.2921,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -669.6279 -1378.2915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M282.26,136.04v1.53l-4.62,14.7h-3.92c-4.2,0-8.37,0.58-12.39,1.72l5.64-17.95H282.26z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M282.26,148.27h-8.55c-5.78,0-11.5,1.1-16.87,3.23l-19.54,7.77v-49.96l19.54,7.77 c5.37,2.13,11.09,3.23,16.87,3.23h8.55V148.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.5331,
    y1: -1776.3616,
    x2: -79.256,
    y2: -1776.3616,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -661.2579 -1373.1864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3011,
    style: {
      stopColor: "#F59F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6384,
    style: {
      stopColor: "#F59F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9921,
    style: {
      stopColor: "#F59F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59F55"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M286.07,148.28h-7.18v-27.96h7.18c1.76,0,3.19,1.43,3.19,3.19v21.58 C289.26,146.85,287.83,148.28,286.07,148.28z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M286.07,138.28h-7.18l0,0h-5.17c-5.78,0-11.5,1.1-16.87,3.23l-19.54,7.77h-11.17c-1.11,0-2-0.89-2-2v10 c0,1.11,0.89,2,2,2h11.17l19.54-7.77c5.37-2.13,11.09-3.23,16.87-3.23h5.17l0,0h7.18c1.76,0,3.19-1.43,3.19-3.19v-10 C289.26,136.85,287.83,138.28,286.07,138.28z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M364.11,131.24v31.88h22.57c5.68,0,10.26-3.42,10.26-7.63v-16.63c0-4.21-4.59-7.62-10.26-7.62H364.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.61,
    y1: -738.724,
    x2: 392.1,
    y2: -738.724,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M384.48,157.21h-31.25c-4.21,0-7.62-3.41-7.62-7.62v-16.63c0-4.21,3.41-7.62,7.62-7.62h31.25 c4.21,0,7.62,3.41,7.62,7.62v16.63C392.1,153.8,388.69,157.21,384.48,157.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.7023,
    y1: -1868.0051,
    x2: -3.8529,
    y2: -1868.0051,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -701.4435 -1320.4095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M364.01,207.96v29.32c0,4.12-3.34,7.45-7.46,7.45h-25.21v-32.72c0-2.24,1.82-4.05,4.05-4.05h3.22v-2.38 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v2.38L364.01,207.96L364.01,207.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.7019,
    y1: -1781.5525,
    x2: 1.7315,
    y2: -1781.5525,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -649.6323 -1322.3153)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M376.34,140.15l-10.25-5.92c-0.88-0.51-1.98,0.13-1.98,1.14v11.84c0,1.02,1.1,1.65,1.98,1.14l10.25-5.92 C377.22,141.93,377.22,140.66,376.34,140.15z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.44,
    y1: -671.069,
    x2: 415,
    y2: -671.069,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M415,73.62c0,8.44-6.84,15.28-15.28,15.28s-15.28-6.84-15.28-15.28s6.84-15.28,15.28-15.28 C408.16,58.34,415,65.18,415,73.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.0339,
    y1: -1718.8282,
    x2: 32.1015,
    y2: -1718.8282,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -605.8027 -1318.6566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "403.66,80.18 392.3,73.62 403.66,67.06 404.25,68.08 394.67,73.62 404.25,79.15  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.6033,
    y1: -1710.2635,
    x2: 31.6233,
    y2: -1710.2635,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -601.3063 -1316.4917)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M401.95,67.57c0-1.11,0.9-2.01,2.01-2.01c1.11,0,2.01,0.9,2.01,2.01s-0.9,2.01-2.01,2.01 S401.95,68.68,401.95,67.57z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.6015,
    y1: -1722.3617,
    x2: 31.6215,
    y2: -1722.3617,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -608.2444 -1314.3036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M401.95,79.67c0-1.11,0.9-2.01,2.01-2.01c1.11,0,2.01,0.9,2.01,2.01s-0.9,2.01-2.01,2.01 S401.95,80.78,401.95,79.67z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1234,
    y1: -1716.3099,
    x2: 21.1435,
    y2: -1716.3099,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -606.6694 -1321.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M391.47,73.62c0-1.11,0.9-2.01,2.01-2.01c1.11,0,2.01,0.9,2.01,2.01s-0.9,2.01-2.01,2.01 C392.37,75.63,391.47,74.73,391.47,73.62z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M384.45,256.31H342.2c-2.69,0-4.86-2.18-4.86-4.86v-39.88h51.97v39.88 C389.32,254.13,387.14,256.31,384.45,256.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.34,
    y1: -803.714,
    x2: 389.31,
    y2: -803.714,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M385.27,200.96h-43.88c-2.24,0-4.05,1.81-4.05,4.05v6.56h51.97v-6.56 C389.32,202.77,387.5,200.96,385.27,200.96z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.75,223.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C348.83,222.75,348.35,223.24,347.75,223.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8096,
    y1: -817.194,
    x2: 357.8096,
    y2: -817.194,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M356.73,223.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C357.81,222.75,357.32,223.24,356.73,223.24z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.7,223.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C366.79,222.75,366.3,223.24,365.7,223.24z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M374.68,223.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C375.76,222.75,375.28,223.24,374.68,223.24z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M383.66,223.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C384.74,222.75,384.25,223.24,383.66,223.24z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.75,232.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C348.83,231.75,348.35,232.24,347.75,232.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8096,
    y1: -826.194,
    x2: 357.8096,
    y2: -826.194,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M356.73,232.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C357.81,231.75,357.32,232.24,356.73,232.24z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.7,232.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C366.79,231.75,366.3,232.24,365.7,232.24z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M374.68,232.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C375.76,231.75,375.28,232.24,374.68,232.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.7383,
    y1: -826.194,
    x2: 384.7383,
    y2: -826.194,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M383.66,232.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C384.74,231.75,384.25,232.24,383.66,232.24z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.75,241.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C348.83,240.75,348.35,241.24,347.75,241.24z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M356.73,241.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C357.81,240.75,357.32,241.24,356.73,241.24z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.7,241.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C366.79,240.75,366.3,241.24,365.7,241.24z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M374.68,241.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C375.76,240.75,375.28,241.24,374.68,241.24z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M383.66,241.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C384.74,240.75,384.25,241.24,383.66,241.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.28,
    y1: -803.719,
    x2: 348.947,
    y2: -803.719,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.28,206.27c0-1.56,1.27-2.83,2.83-2.83c1.57,0,2.83,1.27,2.83,2.83s-1.27,2.83-2.83,2.83 S343.28,207.83,343.28,206.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.28,
    y1: -803.719,
    x2: 382.947,
    y2: -803.719,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M377.28,206.27c0-1.56,1.27-2.83,2.83-2.83c1.57,0,2.83,1.27,2.83,2.83s-1.27,2.83-2.83,2.83 S377.28,207.83,377.28,206.27z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.75,250.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C348.83,249.75,348.35,250.24,347.75,250.24z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M356.73,250.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C357.81,249.75,357.32,250.24,356.73,250.24z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.7,250.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.48-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C366.79,249.75,366.3,250.24,365.7,250.24z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M374.68,250.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C375.76,249.75,375.28,250.24,374.68,250.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.7383,
    y1: -844.194,
    x2: 384.7383,
    y2: -844.194,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M383.66,250.24h-4.83c-0.6,0-1.08-0.49-1.08-1.08v-4.83c0-0.6,0.49-1.08,1.08-1.08h4.83 c0.6,0,1.08,0.48,1.08,1.08v4.83C384.74,249.75,384.25,250.24,383.66,250.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.8375,
    y1: -1844.9388,
    x2: -24.6319,
    y2: -1844.9388,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -689.0171 -1325.3143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M346.11,207.42L346.11,207.42c-0.83,0-1.5-0.67-1.5-1.5v-7.33c0-0.83,0.67-1.5,1.5-1.5l0,0 c0.83,0,1.5,0.67,1.5,1.5v7.33C347.61,206.75,346.94,207.42,346.11,207.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.1607,
    y1: -1844.9387,
    x2: 9.3663,
    y2: -1844.9387,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -682.8683 -1305.8129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M380.11,207.42L380.11,207.42c-0.83,0-1.5-0.67-1.5-1.5v-7.33c0-0.83,0.67-1.5,1.5-1.5l0,0 c0.83,0,1.5,0.67,1.5,1.5v7.33C381.61,206.75,380.94,207.42,380.11,207.42z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.45,155.83c0.85,0,1.62,0.31,2.22,0.83c0.6-0.52,1.37-0.83,2.22-0.83c1.9,0,3.43,1.57,3.43,3.5 s-1.35,3.85-5.65,6.57c-3.48-2.54-5.65-4.64-5.65-6.57C291.01,157.4,292.55,155.83,294.45,155.83z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -1431.05,
    y1: -1017.2616,
    x2: -1419.5876,
    y2: -1017.2616,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -174.3822 -1419.8661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M413.2,227.81c-0.11,0.02-0.23,0.05-0.35,0.07c-2.85,0.54-7.94,0.43-10.18,3.27 c-2.06,2.62,1.85,3.68,5.5,2.9c1.83-0.39,2.95-1.03,3.96-1.17c1.01-0.14,1.91,0.24,2.85,0.08c1.19-0.2,1.31-1.95,1.11-4.2 C415.88,226.51,413.2,227.81,413.2,227.81z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.37,228.95c-0.76,1.15-2.06,1.16-3.54,1.47c-1.03,0.21-2.12,0.77-3.35,1.12 c-3.08,0.88-3.65-1.93-1.34-2.64c1.11-0.34,5.36-0.86,6.18-2.03c0.82-1.16,2.39-0.02,2.39-0.02L415.37,228.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -1451.3922,
    y1: -981.5186,
    x2: -1418.3037,
    y2: -981.5186,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -192.9368 -1433.3295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M430,168.97c1.12,9.56-7.14,23.19-12.29,33.43c3.03,9.36-0.98,22.87-1.41,24.67c-0.34,1.39-4,0.7-3.99-1 c0.04-4.61,0.07-21.2,0.61-26.02c1.07-9.61,3.31-18.82,6.37-25.07c0,0-1.61-12.63,3.82-13.35c0.55-0.08,2.71,0.53,3.32,0.56 C431.64,162.36,429.34,163.35,430,168.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -1448.2209,
    y1: -916.5834,
    x2: -1428.0967,
    y2: -916.5834,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -230.5833 -1446.5039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M419,115.75c-1.5,3.83-6.18,11.02-3.35,15.31c2.82,4.29,4.73,1.8,5.18,7.57c0.44,5.77,6.97-0.36,6.97-0.36 l3.99-9.37L419,115.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -1439.8802,
    y1: -926.5552,
    x2: -1409.6792,
    y2: -926.5552,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -224.6322 -1436.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M428.9,140.35c-3.04,4.49-16.61,7.29-20.12,8.12c-7.08-2.62-13.59-6.26-15.5-7.98 c-1-0.62-0.12-2.83,1.66-2.46c4.38,0.93,9.61,2.77,13.43,4.67c2.98-1.74,16.86-6.65,18.62-5.62 C428.75,138.12,428.9,140.35,428.9,140.35z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.64,119.44c-0.68,1.07-0.58,2.41-0.09,3.97c0.49,1.55-2.29,4.37,1.2,8.51c1.02,0.96,3.49,0.06,4.48-0.28 c0.2,1.28-1.18,3.54-1.18,3.54l4.94,0.53l-0.18-4.01l3.35-10.52l-7.28-5.96L418.64,119.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -1444.405,
    y1: -1019.4188,
    x2: -1434.0598,
    y2: -1019.4188,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -170.7121 -1427.4432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M426.23,229.32c-0.1,0.05-0.21,0.1-0.32,0.15c-2.63,1.23-7.15,2.4-9.33,4.75c-2.27,2.44,2.98,4.05,6.33,2.39 c3.35-1.66,4.58-1.97,6.32-2.75c1.1-0.49,0.79-2.21,0.03-4.34C428.5,227.4,426.23,229.32,426.23,229.32z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.61,229.88c-0.77,2.21-3.33,2.64-6.03,4.21c-2.76,1.61-4.01-0.96-1.95-2.22c0.99-0.6,4.98-2.17,5.48-3.5 s2.31-0.61,2.31-0.61L428.61,229.88z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M420.95,115.72c-1.72,0.91-2.48,3.29-1.6,5.03c0.52,1.03,1.47,1.75,2.21,2.64c0.74,0.88,1.27,2.14,0.75,3.17 c-0.36,0.72-1.2,1.24-1.21,2.05c-0.01,0.69,0.62,1.23,1.27,1.46c0.65,0.23,1.36,0.25,2.01,0.48c1.33,0.48,2.26,1.91,2.14,3.32 s-1.26,2.67-2.66,2.92c1.89,0.64,4.16,0.14,5.64-1.2c1.48-1.33,2.32-3.26,2.68-5.22c0.63-3.47-0.21-7.18-2.27-10.04 C427.85,117.48,424.44,116.22,420.95,115.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -1462.5892,
    y1: -983.3707,
    x2: -1419.5026,
    y2: -983.3707,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -190.6848 -1436.7015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M423.83,176.14c-1.94,6.68-3.25,16.17-2.66,25.83c0.29,4.84,3.11,21.2,3.86,25.74 c0.22,1.34,2.66,1.64,3.66,0.97c0.25-0.15,0.42-0.38,0.44-0.67c0.12-1.85,2.39-16.26-2.2-24.96c3.32-10.97,12.97-27.61,6.43-34.67 c-1.04-1.12-1.87-1.97-2.63-2.6c-2.06-1.72-3.62-1.84-7.4-1.32c-0.59,0.08-1.17,0.21-1.69,0.37 C416.41,166.48,423.83,176.14,423.83,176.14z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M425.29,203.34c2.69,6.63,2.56,17.63,3.33,24.86c0.02,0.15,0.04,0.32,0.08,0.47 c0.25-0.15,0.42-0.38,0.44-0.67c0.12-1.85,2.39-16.26-2.2-24.96c3.32-10.97,12.97-27.61,6.43-34.67c-1.04-1.12-1.87-1.97-2.63-2.6 c-0.41,0.72,0.17,1.5,0.53,2.46c1.34,3.52,0.54,7.7-0.6,11.16c-1.36,4.14-3.43,8.06-4.34,12.31 C425.29,196.55,424.77,198.41,425.29,203.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -1456.1199,
    y1: -938.9075,
    x2: -1425.3213,
    y2: -938.9075,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -216.9094 -1441.8451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M412.14,146.71c-0.03,0.43-0.02,0.86,0.04,1.29c0.17,1.07,0.66,2.14,1.61,3.15 c1.77,1.87,2.79,3.87,3.42,5.69c0.57,1.64,0.83,3.12,1.03,4.27c0.53,2.99-0.02,5.82,0.15,9.22c0.06,1.11,7.34,1.04,13.63-1.12 c0.65-0.22,1.76-0.53,1.08-1.88c-4.72-9.39-4.32-13.33-4.32-23.42c0-2.93,0.35-5.53,1.23-7.53c-3.06-3.29-6.61-2.44-6.61-2.44 c-1.01,2.16-6.42,5.16-8.39,7.16c-0.1,0.11-0.21,0.2-0.3,0.3C413.63,142.58,412.3,144.53,412.14,146.71z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M412.18,148c0.17,1.07,0.66,2.14,1.61,3.15c1.77,1.87,2.79,3.87,3.42,5.69c4.28-3.72,9.28-10.53,9.41-16.96 c0,0-1.73-2.81-2.73-2.35C417.13,140.65,412.85,146.96,412.18,148z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.93,155.68c-0.76-0.16-1.63-0.54-1.63-0.54c-0.51-0.73-1.7-2.12-2.46-2.15 c-0.76-0.03-1.63,0.48-2.34,0.48c0.31,0.92,1.78,0.71,2.42,0.74c0.42,0.85,0.32,0.89,0.29,1.07c-0.8-0.31-2.16,0.11-3.53-0.96 s-2.8-1.66-3.13-1.29c0.8,2.23,0.49,3.62,2,4.31c1.51,0.7,2.7,2.43,4.81,1.44c1.42-1.17,1.82-1.08,2.51-1.14 c0.69-0.05,2.1,0.17,2.1,0.17L395.93,155.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -1436.8235,
    y1: -934.727,
    x2: -1418.2335,
    y2: -934.727,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -221.6398 -1436.2294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M428.09,139.24c-0.52,5.54-11.33,14.78-14.08,17.26c-7.66,1.14-15.65,2.17-18.22,1.57 c-1.21-0.06-1.51-2.49,0.28-3.03c4.41-1.33,10.34-3.34,14.71-3.53c1.82-3.04,11.88-14.32,13.97-14.26 C426.85,137.31,428.09,139.24,428.09,139.24z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M433.11,167.33c-0.04-0.08,0.16,0.75,0.12,0.67c-2.23-4.99-4.77-4.69-5.75-10.05 c-0.33-1.79-0.5-3.63-0.48-5.47c0.03-1.61,0.19-3.23,0.54-4.8c0.28-1.29,0.91-2.51,1.24-3.77 C428.79,154,428.86,160.13,433.11,167.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: -1455.4178,
    y1: -911.0715,
    x2: -1428.5892,
    y2: -911.0715,
    gradientTransform: "matrix(-0.8192 -0.5736 0.5736 -0.8192 -231.4212 -1449.223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M424.24,121.75c1.44,1.05,1.93,2.98,1.93,4.76c0,1.78-0.38,3.55-0.25,5.33c0.21,3.04,2.03,5.92,4.67,7.43 c0.61,0.35,1.35,0.63,2,0.36c0.55-0.23,0.88-0.79,1.15-1.32c1.8-3.5,3.04-7.36,3.1-11.29s-1.14-7.97-3.72-10.94 c-2.73-3.15-7.09-4.97-11.24-4.09c-1.41,0.3-3.11,0.82-3.88,2.15c-0.76,1.33-0.62,3.56,0.25,4.79 C419.65,120.88,422.43,120.42,424.24,121.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: -516.6396,
    y1: -1457.2058,
    x2: -522.6126,
    y2: -1458.2593,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -164.3471 -1227.3026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M242.81,257.32c-0.2,0.03-0.7,0.13-0.92,0.27c0.02,0.39,0.38,2.29,3.44,7.07c1.44,2.24,1.65,4.22,2.1,5.09 c1.11,2.19,1.95,2.84,2.39,2.62c0.79-0.57,2.23-1.78,2.23-1.78L242.81,257.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -520.0817,
    y1: -1456.4958,
    x2: -513.7344,
    y2: -1456.4958,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -163.6752 -1226.306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M253.55,265.29c-1.19-0.41-2.6-1.55-4.18-3.19c-1.78-1.85-2.77-2.56-4.23-4.43c-0.9-1.02-1.54-0.8-2.34-0.35 c0.5,2.15,1.47,3.79,2.53,5.25c1.06,1.45,2.4,3.52,2.7,5.07c0.59,1.61,1.93,3.99,2.56,4.02c1.28-0.86,4.37-3.32,4.37-3.32 L253.55,265.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -508.8603,
    y1: -1460.0941,
    x2: -448.3821,
    y2: -1460.0941,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -156.1449 -1204.1156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M322.9,270.45c0,0-24.47,2.14-36.26-0.53c-3.24,0.39-22.23,2.25-32.22-0.45c-0.28-0.49-0.55-0.98-0.8-1.46 c-0.59-1.17-0.98-2.29-0.76-3.44c12.45-0.73,32.8-1.91,32.8-1.91l32.91-7.02l3.74,12.79L322.9,270.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.7978,
    y1: -860.8998,
    x2: 322.9,
    y2: -860.8998,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M322.9,270.45c0,0-24.47,2.14-36.26-0.53c-3.24,0.39-22.23,2.25-32.22-0.45c-0.28-0.49-0.55-0.98-0.8-1.46 c-0.59-1.17-0.98-2.29-0.76-3.44c12.45-0.73,32.8-1.91,32.8-1.91l32.91-7.02l3.74,12.79L322.9,270.45z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M322.9,270.45c0,0-24.47,2.14-36.26-0.53c-7.66,2.6-22.23,2.25-32.22-0.45c-0.28-0.49-0.55-0.98-0.8-1.46 c0.46-0.01,0.94,0.02,1.4,0.05c2.96,0.2,5.93,0.31,8.89,0.34c1.23,0,2.45-0.01,3.67-0.09c3.69-0.27,7.31-1.25,11.01-1.52 c6.11-0.45,12.1,2.22,18.22,2.54c5.19,0.5,10.61-2.52,15.69-1.79c2.7,0.39,6.72-0.01,9.82,0.88L322.9,270.45z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.71,233.24c-1.39-1.3-1.28-2.46-1.66-4.01c-0.39-1.55-3.49-4.01-5.41-4.07 c-1.93-0.05-3.56,0.37-3.56,0.37c1.33,1.67,4.08,1.63,5.01,3.12c0.93,1.49,1.4,2.21,1.79,2.73c-1.21-0.44-1.61-1.61-2.48-2.27 c-0.87-0.66-1.58-1.48-2.23-0.84c0.65,0.61,1.7,1.68,2.07,2.24c0.37,0.56,1.02,3.21,2.33,3.21s2.26,0.37,2.99,1.12 C301.29,235.59,301.71,233.24,301.71,233.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -498.0707,
    y1: -1473.6675,
    x2: -510.6882,
    y2: -1464.8328,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -168.0807 -1216.9691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M254.36,274.31c-0.42,0.51-0.61,0.97-0.56,1.24c0.04,0.27,0.12,1.12,2.24,1.92c2.8,1.07,4.5,0.75,7.71,0.71 c3.03-0.04,4.43-0.16,5.09-1.1c0.66-0.95,0.2-3.43,0.2-3.43l-6.44,0.82L254.36,274.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -511.1121,
    y1: -1467.7069,
    x2: -496.114,
    y2: -1467.7069,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -166.5307 -1217.1312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M265.64,270.08c-1.53,1.13-3.3,1.64-5.12,2.35c-1.11,0.43-3.77,0.81-4.89,1.15 c-1.12,0.34-1.67,1.01-1.38,1.39c0.29,0.39,2.17,1.4,3.91,1.62c3.03,0.37,4.78,0.01,7.5-0.1c2.59-0.1,3.37-0.81,3.49-1.76 s0.7-3.63,0.7-3.63L265.64,270.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.5916,
    y1: -1471.0127,
    x2: -495.1823,
    y2: -1433.4886,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -151.8188 -1199.3954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M310.18,267.22c-4.53-2.71-11.99-7.53-17.19-13.66c-4.13,8.54-10.75,8.2-23.23,18.09 c-1.3,1.4-5.85,0.73-4.84-1.47c4.27-4.39,11.04-11.67,25.66-23.98c1.51-1.27,3.93-0.5,5.74,0.32 c12.02,5.47,22.72,11.31,28.79,14.99c-1.87,2.05,4.75-5.53,5.08-1.19c0.12,1.49-0.84,6.36-1.52,7.44 C324.68,274.16,314.12,272.09,310.18,267.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -461.9506,
    y1: -1428.8654,
    x2: -435.7079,
    y2: -1428.8654,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -136.949 -1193.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M323.9,229.15c-2.72,1.34-9.58,9.1-11.32,12.8c-2.15-3.56-8.65-8.05-10.48-9.42 c-1.25-1.21-3.83,1.68-2.65,2.76c1.23,1.86,11.33,10.39,13.23,12.2c1.9,1.8,17.17-14.5,17.17-14.5L323.9,229.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -477.2289,
    y1: -1425.8179,
    x2: -472.5317,
    y2: -1425.8179,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -137.8359 -1207.9012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M296.91,238.57l0.12-0.12c0.38-0.38,0.38-0.98,0-1.36l-10.61-10.61c-0.37-0.38-0.98-0.38-1.36,0l-0.12,0.12 c-0.38,0.38-0.38,0.98,0,1.36l10.6,10.61C295.93,238.94,296.54,238.94,296.91,238.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -456.1784,
    y1: -1437.6896,
    x2: -422.0663,
    y2: -1437.6896,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -137.6127 -1185.7562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M337.34,235.29c-0.09,0.47-0.19,0.97-0.32,1.49c-1.88,7.71-3.86,9.91-6.46,21.86 c-0.12,0.54-0.24,1.1-0.36,1.68c-1.03,4.98-13.06-1.85-15.38-4.55c0.1-1.2,1.09-1.76,1.61-3.57c1.21-4.11,2.51-8.17,2.83-14.02 c0.03-0.57,0.06-1.16,0.07-1.77c0.02-0.76,0.2-1.51,0.56-2.19c1.76-3.35,6.11-8.62,6.11-8.62l8.5-1.2 C335.67,227.2,338.57,228.55,337.34,235.29z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M336.23,231.87c-1.1,5.2-9.08,17.52-19.8,20.33c1.21-4.11,2.51-8.18,2.83-14.02c1.23-1.46,3.54-2,6.23-4.77 c2.82-2.91,3.67-4.26,3.67-4.26L336.23,231.87z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.6,223.49l-0.17,0.02l-3.6,0.39l-1.46,0.16l-0.29-2.75c-1.66,1.85-4.23,3.55-6.62-0.08 c-1.78-2.64-2.88-4.59-3.59-7.6c-0.19-0.79-0.35-1.65-0.49-2.62l14.9-2.74l1.31,15.17L333.6,223.49z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M333.59,223.43l-0.16,0.08l-3.46,1.64c0.05-0.43-0.02-0.84-0.15-1.25c-0.44-1.44,0.02-1.92,0.14-3.45 c0.03-0.35-0.49-2.12-0.58-2.46c-0.21-0.83-2.38-0.44-3.02-1.01c-1.21-1.1-0.41-3.31-1.42-4.6c-0.45-0.59-1.21-0.87-1.96-0.92 c-0.74-0.04-1.48,0.13-2.2,0.29l-2.92,1.88c-0.19-0.79-0.35-1.65-0.49-2.62l14.9-2.74L333.59,223.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -434.2107,
    y1: -1408.2296,
    x2: -449.4982,
    y2: -1397.5254,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -118.7019 -1193.1058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3628,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#0B0B0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5951,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6741,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#3E3E3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8023,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#7A7A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9073,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "#CBCBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M332.98,215.95c-2.68-0.04-1.08-3.54-3.15-3.54s-1.14,2.71-2.72,1.46c-2.15-1.49-2.3-3.45-5.38-2.39 c-3.08,1.06-3.97,2.45-5.45,1.9s-2.21-3.28-0.92-4.68c1.4-1.53,3.51-2.93,5.65-3.78c1.75-0.69,1.59-2.89,5.13-0.89 c1.22-1.35,4.92-0.58,5.06,1.23C334.18,206.16,333.31,211.14,332.98,215.95z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.31,239.04c-0.75-0.09-4.48-0.21-5.88-1.49s-4.15-5.37-5.13-5.88c0.98-1.22,3.22,0.12,3.97,1.34 s3.13,3.1,4.24,3.19c0.24-1.28-0.27-1.64-1.07-2.06c-0.78-0.42-0.96-2-0.57-2.42c0.2-0.15,1.02,1.01,1.58,1.19 c0.57,0.18,1.58,1.01,1.67,1.64c0.09,0.63,0.83,2.43,1.34,2.48c0.52,0.04,2,0.81,2,0.81L297.31,239.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -466.3419,
    y1: -1431.0579,
    x2: -428.7065,
    y2: -1431.0579,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -136.4062 -1192.1532)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M336.19,231.51c-0.02,0.94-0.41,1.94-1.24,2.9c-3.97,4.54-8.71,13.87-19.1,15.21 c-9.48-2.32-17.59-7.34-18.67-9.48c0.03-0.45,0.08-0.85,0.14-1.21c0.44-2.46,1.53-2.76,2.55-3c3.84,2.33,11,5.01,15.57,7.43 c7.63-5.12,8.92-6.83,14.14-15.53C331.48,224.65,336.29,228.57,336.19,231.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -442.9865,
    y1: -1419.0278,
    x2: -431.3351,
    y2: -1419.0278,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -126.8074 -1187.3138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFD4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#84ACB9"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M326.38,224.36l-3.05,3.46c-0.05,0.06,0,0.16,0.08,0.14L335,225.2l-1.11-2.5l-6.14,0.92 C327.22,223.7,326.74,223.96,326.38,224.36z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M337.34,235.29c-0.09,0.47-0.19,0.97-0.32,1.49c-1.88,7.71-3.86,9.91-6.46,21.86 c-0.46-0.73-0.9-1.48-1.27-2.26c-0.88-1.86-1.36-4.06-0.62-5.98c0.47-1.24,1.39-2.23,2.18-3.3c1.8-2.41,2.96-5.23,4.11-8.02 c0.39-0.94,0.72-2.67,1.5-3.37C336.68,235.51,336.99,235.38,337.34,235.29z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.4,254.72c-0.78,0.1-1.34,0-1.58-0.2c-0.24-0.21-1.04-0.82-0.54-3.43c0.66-3.46,2.03-4.96,4.05-8.15 c1.91-3,2.9-4.33,4.25-4.4c1.35-0.07,3.55,1.92,3.55,1.92l-4.8,5.92L186.4,254.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.5854,
    y1: -844.567,
    x2: 199.18,
    y2: -844.567,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M197.6,246.07c-2.08,0.83-3.68,2.28-5.52,3.67c-1.12,0.84-3.14,3.26-4.17,4.17s-2.04,1.04-2.24,0.52 c-0.21-0.53-0.06-3.04,0.8-4.91c1.5-3.26,2.94-4.79,4.73-7.44c1.7-2.52,2.89-2.87,3.92-2.4c1.03,0.46,4.06,1.54,4.06,1.54 L197.6,246.07z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -614.6109,
    y1: -1628.3973,
    x2: -571.6862,
    y2: -1628.3973,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -233.0419 -1438.0311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9B183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBD6B6"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M229.64,224.82c-6.79,0.98-29.25,11.04-34.37,15.92c-0.88,3.34,0.33,5.81,1.78,6.39 c3.17-0.72,28.83-8.22,35.92-13.99C237.6,229.43,234.86,224.07,229.64,224.82z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.71,256.45c0.73,0.28,1.3,0.31,1.59,0.17c0.28-0.15,1.2-0.55,1.31-3.21c0.15-3.52-0.83-5.3-2.06-8.86 c-1.16-3.36-1.82-4.88-3.12-5.27c-1.3-0.38-3.9,1.05-3.9,1.05l3.3,6.87L226.71,256.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.0059,
    y1: -845.5909,
    x2: 217.4,
    y2: -845.5909,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9628,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M217.82,245.44c1.83,1.29,3.05,3.07,4.52,4.84c0.89,1.08,2.3,3.9,3.09,5.03c0.79,1.12,1.74,1.48,2.06,1.02 c0.32-0.46,0.76-2.94,0.35-4.96c-0.71-3.52-1.75-5.34-2.88-8.33c-1.07-2.85-2.15-3.46-3.25-3.24c-1.11,0.21-4.31,0.57-4.31,0.57 L217.82,245.44z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.91,179.43c0.21,0.98-0.09,1.87-0.67,1.99c-0.57,0.12-1.21-0.57-1.41-1.55 c-0.21-0.98,0.09-1.87,0.67-1.99C202.08,177.75,202.71,178.45,202.91,179.43z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.11,179.91c-0.25,0.97-0.91,1.63-1.48,1.49c-0.57-0.15-0.83-1.05-0.58-2.02s0.91-1.63,1.48-1.49 C215.1,178.04,215.36,178.94,215.11,179.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.7713,
    y1: -777.098,
    x2: 202.9788,
    y2: -777.098,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M202.91,179.43c0.21,0.98-0.09,1.87-0.67,1.99c-0.57,0.12-1.21-0.57-1.41-1.55 c-0.21-0.98,0.09-1.87,0.67-1.99C202.08,177.75,202.71,178.45,202.91,179.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.9615,
    y1: -777.094,
    x2: 215.2071,
    y2: -777.094,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M215.11,179.91c-0.25,0.97-0.91,1.63-1.48,1.49c-0.57-0.15-0.83-1.05-0.58-2.02s0.91-1.63,1.48-1.49 C215.1,178.04,215.36,178.94,215.11,179.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -622.3732,
    y1: -1628.2555,
    x2: -594.6676,
    y2: -1628.2555,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -235.6199 -1447.0253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9B183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBD6B6"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M185.87,224.65c6.68,1.57,28.63,10.77,33.88,15.51c0.97,3.31-0.17,5.81-1.61,6.43 c-3.19-0.64-29.04-7.45-36.28-13.03C175.96,229.16,180.53,223.39,185.87,224.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.14,
    y1: -803.229,
    x2: 238.1546,
    y2: -803.229,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M238.15,207.08c0.19,1.36-5.51,8.18-12.54,13.91l-0.52-0.37l-0.21-0.16l-1.42-1.02 c2.1-2.22,6.79-10.03,9.4-11.84c-3.58-2.82-10.86-9.51-12.72-10.91c0.01-1.62,0.14-4.83,0.69-6.1c0-0.01,0.01-0.02,0.01-0.02 c3.79,1.72,7.43,4.2,10.86,7.84C233.93,200.76,236.09,203.62,238.15,207.08z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M238.15,207.08c0.19,1.36-5.51,8.18-12.54,13.91l-0.52-0.37c0.23-0.3,0.46-0.57,0.62-0.8 c1.13-1.57,2.26-3.13,3.4-4.69c0.63-0.88,1.27-1.76,1.91-2.64c0.81-1.13,1.64-2.26,2.64-3.23s2.2-1.77,3.56-2.1 c-2.64-1.38-4.69-3.85-5.57-6.7c-0.14-0.47-0.26-0.98-0.18-1.47c0.04-0.2,0.12-0.4,0.23-0.58 C233.93,200.76,236.09,203.62,238.15,207.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: -575.1696,
    y1: -1593.7557,
    x2: -587.606,
    y2: -1585.0479,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -208.6781 -1438.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1937,
    style: {
      stopColor: "#F5A282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    style: {
      stopColor: "#F6AA8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    style: {
      stopColor: "#F8B79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    style: {
      stopColor: "#FACBB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    style: {
      stopColor: "#FCE3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M220.93,189.51c-0.44-0.19-0.77,0.1-1.02,0.67c-0.84,1.93-0.77,7.01-0.77,7.01s5.44,4.07,9.25,7.36 c1.79,1.22,6.93-2.75,5.76-4.13C230.76,196.11,226.37,191.88,220.93,189.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.2554,
    y1: -803.219,
    x2: 195.27,
    y2: -803.219,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M190.54,220.46l1.41-1.03c-2.09-2.21-6.79-10.03-9.39-11.84c3.58-2.81,10.86-9.51,12.71-10.9 c-0.01-1.62-0.13-4.83-0.69-6.11c0-0.01,0-0.01-0.01-0.02c-6.26,2.83-12.08,7.75-17.31,16.51c-0.19,1.36,5.51,8.18,12.54,13.91 L190.54,220.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -613.2014,
    y1: -1593.7555,
    x2: -625.6379,
    y2: -1585.0477,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -215.56 -1460.2323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M194.49,189.51c0.44-0.19,0.77,0.1,1.02,0.67c0.84,1.93,0.77,7.01,0.77,7.01s-5.44,4.07-9.25,7.36 c-1.79,1.22-6.93-2.75-5.76-4.13C184.66,196.11,189.05,191.88,194.49,189.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: -620.5365,
    y1: -1600.0238,
    x2: -579.5239,
    y2: -1600.0238,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -217.8279 -1447.5179)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#F5A180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5374,
    style: {
      stopColor: "#F6A687"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    style: {
      stopColor: "#F7AF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    style: {
      stopColor: "#F8BCA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8432,
    style: {
      stopColor: "#FACEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    style: {
      stopColor: "#FCE3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#FFFBFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "218.88,227.67 197.56,227.67 194.52,189.51 207.71,186.47 220.91,189.51  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.06,178.8v9.66h0.04v2.15c0,1.99,1.61,3.6,3.6,3.6s3.6-1.61,3.6-3.6v-2.15V187v-8.2H204.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.06,
    y1: -783.954,
    x2: 211.31,
    y2: -783.954,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M204.06,178.8v9.66h0.04v2.15c0,1.99,1.61,3.6,3.6,3.6s3.6-1.61,3.6-3.6v-2.15V187v-8.2H204.06z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M220.44,198.35c-0.14,0.08-0.28,0.18-0.42,0.31c-3.35,3.07-4.1,9.88-3.37,14.04 c0.45,2.59,1.47,5.04,2.63,7.41L220.44,198.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.1822,
    y1: -777.499,
    x2: 214.8015,
    y2: -777.499,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#BE714D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#6E450E"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M213.27,182.57c-1.44,3.1-3.04,4.68-4.28,5.31c-0.48,0.25-0.91,0.36-1.25,0.36c-1.22,0-3.89-1.92-5.23-5.67 c-1.06-2.98-1.84-4.76-0.92-7.34c0.92-2.59,3.41-3.37,6.15-3.37c0.64,0,1.29,0.07,1.93,0.2c2.06,0.41,3.9,1.4,4.52,2.36 C215,175.68,215.28,178.26,213.27,182.57z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M213.27,182.57c-1.44,3.1-3.04,4.68-4.28,5.31c0.57-0.81,1.45-1.46,1.78-2.4c0.43-1.24-0.19-2.68,0.32-3.89 c0.21-0.5,0.61-0.91,0.86-1.4c0.5-0.95,0.39-2.09,0.29-3.16c-0.08-0.83-0.24-1.77-0.96-2.19c-0.56-0.34-1.28-0.22-1.93-0.18 c-1.94,0.1-3.89-0.64-5.26-2.01c0.81-0.3,1.61-0.55,2.48-0.57c1.03-0.03,2.06-0.05,3.09-0.03c2.06,0.41,3.9,1.4,4.52,2.36 C215,175.68,215.28,178.26,213.27,182.57z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M215.59,176.79c-0.32,1.18-0.79,2.34-1.4,3.4c0.33-1.13-0.46-1.12-0.11-2.42c0.51-1.91-0.24-3.98-1.4-4.52 c-1.27-0.59-2.71,1.17-4.15,1.21c-2.53,0.06-3-1.72-5.37-0.76c-1.58,0.65-1.15,7.79-1.79,5.49c-0.65-3.09-2.27-6.32-0.38-8.99 c1.64-2.37,3.59-3.83,5.57-4.4c3.18-0.92,6.44,0.47,8.6,4.09C216.27,171.5,216.32,174.17,215.59,176.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.85,
    y1: -818.104,
    x2: 226.75,
    y2: -818.104,
    gradientTransform: "matrix(1 0 0 -1 0 -597.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M226.74,231.12h-38.89v-20c0-0.51,0.41-0.93,0.93-0.93h37.04c0.51,0,0.93,0.42,0.93,0.93L226.74,231.12 L226.74,231.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -584.9059,
    y1: -1635.4702,
    x2: -616.7612,
    y2: -1613.1653,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -232.2239 -1443.245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8B9C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8FFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 187.84,
    y: 231.12,
    className: "st73",
    width: 38.89,
    height: 1.83
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.460568edacb7890b3605e5893c1a1412.svg";
export { ForwardRef as ReactComponent };